app-platform-tool-treaty-other-document-wrapper-content{display:flex;flex-grow:1;height:0}
/*# sourceMappingURL=platform-tool-treaty-other-document-wrapper-content.component-WXF3JO34.css.map */
